import Routes from 'routes/index'
import React, { Suspense, useEffect } from 'react'
import Loader from 'components/ui-kit/Loader/index'
import { removeAuthTokenFromCookie } from 'helpers/cookie.helpers'
import * as NP from 'number-precision'

NP.enableBoundaryChecking(false)

function App () {
  useEffect(() => {
    console.log('version : 3')
    removeAuthTokenFromCookie()
  }, [])

  return (
    <Suspense fallback={<Loader />}>
      <Routes />
    </Suspense>
  )
}

export default App
